import React, { memo } from "react";

import { useIntl } from "react-intl";

import { Deal } from "@mapmycustomers/shared/types/entity";

import AddOrCreateDropdown from "@app/component/preview/components/AddOrCreateDropdown";
import Section from "@app/component/preview/components/Section";

import styles from "../../Relationships.module.scss";
import EditDealsPanel from "../EditDealsPanel";

interface Props {
  addDealLoading?: boolean;
  deals: Deal[];
  onAddExisting: () => void;
  onAddNew: () => void;
  onFetchMoreDeals?: () => void;
  onRemove?: (deal: Deal) => void;
  totalDeals: number;
}

const Deals: React.FC<Props> = ({
  addDealLoading = false,
  deals,
  onAddExisting,
  onAddNew,
  onFetchMoreDeals,
  onRemove = () => {},
  totalDeals,
}) => {
  const intl = useIntl();

  return (
    <Section
      action={
        <AddOrCreateDropdown
          loading={addDealLoading}
          onAddExisting={onAddExisting}
          onAddNew={onAddNew}
        />
      }
      title={intl.formatMessage(
        {
          id: "entityPreview.relationships.deals.title",
          defaultMessage: "Deals ({count})",
          description: "Deals section title of the preview record pane",
        },
        { count: totalDeals }
      )}
      titleClassName={styles.sectionTitle}
    >
      <div className={styles.container}>
        <EditDealsPanel
          deals={deals}
          onFetchMoreDeals={onFetchMoreDeals}
          onRemove={onRemove}
          totalDeals={totalDeals}
        />
        {deals.length !== 1 ? null : (
          // a dummy div to force single deal be in a first column
          <div />
        )}
      </div>
    </Section>
  );
};

export default memo(Deals);
